module.exports = __webpack_public_path__ + "img/danni-fisher-shin-reality-filter.b314012.jpg";